import React from "react";
import PropTypes from "prop-types";

const shapes = {
  circle: "rounded-[50%]",
  square: "rounded-[0px]",
  round: "rounded-[14px]",
};
const variants = {
  outline: {
    secondary__primary_white: "border-secondary-primary_white border-[3px] border-solid",
    gray_200: "border-gray-200 border border-solid text-black-900",
    gray_600: "border-gray-600 border border-solid",
  },
  fill: {
    red_A700_03: "bg-red-a700_03 text-secondary-primary_white",
    red_800: "bg-red-800 text-secondary-primary_white",
    black_900_33_01: "bg-black-900_33_01",
    black_900_cc: "bg-black-900_cc",
    secondary__primary_white: "bg-secondary-primary_white text-black-900_03",
    black_900: "bg-black-900 text-secondary-primary_white",
    gray_200_01: "bg-gray-200_01 text-red-a700_03",
    yellow_800: "bg-yellow-800 text-secondary-primary_white",
    deep_orange_500: "bg-deep_orange-500 text-secondary-primary_white",
    black_900_b2: "bg-black-900_b2 text-secondary-primary_white",
    gray_700_04: "bg-gray-700_04 text-secondary-primary_white",
    gray_800_02: "bg-gray-800_02",
    gray_100_03: "bg-gray-100_03",
    light_green_800: "bg-light_green-800 text-secondary-primary_white",
    black_900_03: "bg-black-900_03 text-secondary-primary_white",
    white_A700_26: "bg-white-a700_26",
  },
};
const sizes = {
  "10xl": "h-[62px] px-4",
  "9xl": "h-[56px] px-[18px]",
  "5xl": "h-[46px] pl-5 pr-4 text-[16px]",
  "2xl": "h-[40px] px-5 text-[20px]",
  "8xl": "h-[56px] px-8 text-[24px]",
  "3xl": "h-[40px] px-3",
  xs: "h-[22px] px-1",
  "6xl": "h-[50px] px-4 text-[16px]",
  "4xl": "h-[40px] px-2.5 text-[16px]",
  xl: "h-[36px] px-2",
  md: "h-[32px] px-1.5",
  lg: "h-[34px] px-1.5 text-[16px]",
  "7xl": "h-[52px] px-4",
  sm: "h-[30px] px-4 text-[14px]",
};

const Button = ({
  children,
  className = "",
  leftIcon,
  rightIcon,
  shape,
  variant = "fill",
  size = "sm",
  color = "",
  ...restProps
}) => {
  return (
    <button
      className={`${className} flex flex-row items-center justify-center text-center cursor-pointer whitespace-nowrap ${shape && shapes[shape]} ${size && sizes[size]} ${variant && variants[variant]?.[color]}`}
      {...restProps}
    >
      {!!leftIcon && leftIcon}
      {children}
      {!!rightIcon && rightIcon}
    </button>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  leftIcon: PropTypes.node,
  rightIcon: PropTypes.node,
  shape: PropTypes.oneOf(["circle", "square", "round"]),
  size: PropTypes.oneOf(["10xl", "9xl", "5xl", "2xl", "8xl", "3xl", "xs", "6xl", "4xl", "xl", "md", "lg", "7xl", "sm"]),
  variant: PropTypes.oneOf(["outline", "fill"]),
  color: PropTypes.oneOf([
    "secondary__primary_white",
    "gray_200",
    "gray_600",
    "red_A700_03",
    "red_800",
    "black_900_33_01",
    "black_900_cc",
    "black_900",
    "gray_200_01",
    "yellow_800",
    "deep_orange_500",
    "black_900_b2",
    "gray_700_04",
    "gray_800_02",
    "gray_100_03",
    "light_green_800",
    "black_900_03",
    "white_A700_26",
  ]),
};

export { Button };
